import { Route, Routes } from "react-router"
import { Main } from "../pages/main"
import { DashboardReportFolioProvider } from "../provider"
import { ReportFolioDetailProvider } from "../pages/detail/provider"
import { ReassignUser } from "../pages/reassignUser"
import { ReassigUserProvider } from "../pages/reassignUser/context"
import { FormCorrective } from "../pages/FormCorrective"
import { FormPreventive } from "../pages/FormPreventive"


const DashboardReportFolioRoutes = () => {
    return (
        <DashboardReportFolioProvider>
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="detail/:id" element={<ReportFolioDetailProvider />} />
                <Route path="detail/reassign-user/:id" element={<ReassigUserProvider><ReassignUser /></ReassigUserProvider>} />
                <Route path="correctivo/:id?" element={<FormCorrective />} />
                <Route path="preventivo/:id?" element={<FormPreventive />} />
            </Routes>
        </DashboardReportFolioProvider>
    )
}

export { DashboardReportFolioRoutes }
